import type { RequestConfig } from "@app/config/axios/http";
import { stockInplantsApi } from "./api.core";
import type { ApiStockInplantData, StockInplantFilter } from "./types";

/** Сервисный слой — ВЗН СУ. */
export const stockInplantsServices = {
    /**
     * Загружает ВЗН СУ по фильтру.
     * @param params фильтр ВЗН СУ
     * @param config опции HTTP-запроса
     */
    load: async (
        params: {
            flt?: StockInplantFilter;
        },
        config?: RequestConfig,
    ): Promise<ApiStockInplantData[]> => {
        return stockInplantsApi.load(params, config);
    },
} as const;
